import React from 'react';
import Datatable from '../../../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import * as RegistrationDetailSelector from '../../../../../../redux/reducers/registration_detail_reducer/selectors';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';

interface IProps {
  mode: 'VIEW' | 'EDIT';
}

export default function FixedEstablishmentsDataTable(props: IProps) {
  const result = RegistrationDetailSelector.useFixedEstablishmentsDetails();

  return (
    <Datatable
      loading={true}
      paging={undefined}
      data={result}
      columns={TableColumns(props.mode)}
    />
  );
}
